import * as types from '../actions/actionTypes';
import initialState from './initialState';
import {some, sortBy} from 'lodash';

const addBdmClient = (state, action) =>{
  let {bdm, client} = action.bdmClient;
  let bdmsAdd = [...state.items].map(x => {
    let returnVal = {...x};
    if (returnVal.id == bdm.id) {
      if (!_.some(returnVal.clients, y => y.id == client.id)) {
        returnVal.clients = _.sortBy([...returnVal.clients, client], x => x.clientName.toLowerCase());
      }
    } else {
      returnVal.clients = [...returnVal.clients.filter(x => x.id != client.id)];
    }
    return returnVal;
  });

  return bdmsAdd;
};

const removeBdmClient = (state, action) =>{
  let {bdm, client} = action.bdmClient;
  let bdmsRemove = [...state.items].map(x => {
    let returnVal = {...x};
    if (returnVal.id == bdm.id) {
      returnVal.clients = [...returnVal.clients.filter(x => x.id != client.id)];
    }
    return returnVal;
  });
  return bdmsRemove;
};


export default function bdmsReducer(state = initialState.bdms, action) {
  switch (action.type) {
    case types.LOAD_BDMS_SUCCESS:
      return {...action.bdms};
    case types.SAVE_BDM_CLIENT_SUCCESS:
      return {...state.bdms, items: addBdmClient(state, action)};

    case types.DELETE_BDM_CLIENT_SUCCESS:

      return {...state.bdms, items: removeBdmClient(state, action)};
    default:
      return state;
  }
}
